import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

export default function About() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <Navbar />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            About Us
          </h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        <Card className="shadow-lg border-0 bg-white/80 backdrop-blur-sm">
          <CardContent className="p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              <div className="text-gray-700 leading-relaxed space-y-6">
                <p className="text-lg">
                  At PrizeDrop.co.za, we are redefining what a "competition platform" means in South Africa. We believe prizes should not only be about luck, they should open doors to opportunity, connection, and empowerment.
                </p>
                
                <p>
                  That's why we've built more than a giveaway site. Prize Drop is a dynamic digital community designed to connect people to real possibilities, from bursaries and training programmes to work opportunities, mentorship, and financial inclusion.
                </p>
                
                <p>
                  Our mission is simple yet transformative: to make opportunity accessible. We help South Africans find their next breakthrough, whether it's winning a prize that changes their daily life, getting connected to a bursary that unlocks their educational journey towards future venture success or networking with employers and partners who believe in shared growth.
                </p>
                
                <p>
                  Prize Drop is powered by purpose and people, not just prizes. Every campaign and giveaway we host is crafted to build bridges between education, employability, and economic mobility. We partner with credible brands, community projects, and training institutions to ensure every prize or bursary aligns with South Africa's real needs: job readiness, digital inclusion, and youth empowerment.
                </p>
                
                <p>
                  We are not just giving away rewards, we are building a network of hope, access, and upward mobility. By participating, users become part of a national ecosystem where winning means more than getting something free; it means stepping into the next chapter of their journey with tools, skills, and confidence.
                </p>
                
                <p>
                  From free community challenges to sponsored bursary entries and skills-development initiatives, PrizeDrop.co.za is where purpose meets possibility, one entry, one opportunity, one empowered South African at a time.
                </p>
                
                <div className="flex items-center justify-center my-8">
                  <div className="text-2xl text-gray-400">⸻</div>
                </div>
                
                <Separator className="my-8" />
                
                <div className="bg-blue-50 rounded-lg p-6 border-l-4 border-blue-600">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white text-sm font-bold mr-3">
                      ✦
                    </span>
                    Vision
                  </h2>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    To become South Africa's leading platform for opportunity access—where every entry connects people to education, employment, and empowerment opportunities that transform lives and build stronger communities.
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
        
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 text-gray-500">
            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
            <span className="text-sm font-medium">Building communities, one entry at a time</span>
            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}